import React from 'react';
import Plot from 'react-plotly.js';

const PairPlot = ({ data, numcols, categoricalColumn = null, showUniqueCombinations = false }) => {
    const numColumns = numcols.length;

    const uniqueCategories = categoricalColumn
        ? [...new Set(data[categoricalColumn])]
        : [];
    const colors = uniqueCategories.map((_, index) => `hsl(${index * (360 / uniqueCategories.length)}, 100%, 50%)`);
    const traces = [];
    let axisIndex = 1;

    for (let i = 0; i < numColumns; i++) {
        for (let j = 0; j < numColumns; j++) {
            if (!showUniqueCombinations || i !== j) {
                if (categoricalColumn) {
                    uniqueCategories.forEach((category, index) => {
                        const trace = {
                            x: data[numcols[j]]?.filter((_, idx) => data[categoricalColumn][idx] === category),
                            y: data[numcols[i]]?.filter((_, idx) => data[categoricalColumn][idx] === category),
                            mode: 'markers',
                            type: 'scatter',
                            marker: {
                                color: colors[index],
                                size: 6,
                            },
                            name: category,
                            legendgroup: category,
                            showlegend: traces.length === 0 || (i === 0 && j === 1 && showUniqueCombinations),
                            xaxis: `x${axisIndex}`,
                            yaxis: `y${axisIndex}`,
                        };
                        traces.push(trace);
                    });
                } else {
                    const trace = {
                        x: data[numcols[j]],
                        y: data[numcols[i]],
                        mode: 'markers',
                        type: 'scatter',
                        marker: {
                            color: 'blue',
                            size: 6,
                        },
                        showlegend: false,
                        xaxis: `x${axisIndex}`,
                        yaxis: `y${axisIndex}`,
                    };
                    traces.push(trace);
                }
                axisIndex++;
            }
        }
    }

    // Layout settings
    const layout = {
        grid: {
            rows: numColumns,
            columns: numColumns-1,
            pattern: 'independent'
        },
        showlegend: true,
        height: 450 * numColumns,
        width: 450 * numColumns,
        legend: {
            orientation: 'h',
            x: 0.5,
            y: 1.1,
            xanchor: 'center',
        },
        margin: {
            t: 50,
        },
        
    };

    axisIndex = 1;
    for (let i = 0; i < numColumns; i++) {
        for (let j = 0; j < numColumns; j++) {
            if (!showUniqueCombinations || i !== j) {
                layout[`xaxis${axisIndex}`] = { title: numcols[j], showticklabels: i === numColumns - 1 };
                layout[`yaxis${axisIndex}`] = { title: numcols[i], showticklabels: j === 0 };
                axisIndex++;
            }
        }
    }

    return <Plot data={traces} layout={layout}  useResizeHandler={true} config={{ responsive: true }} style={{ width: '100%', height: 'auto' }}/>;
};

export default PairPlot;
